import script from "./BuddyListGroup.vue?vue&type=script&lang=ts&setup=true"
export * from "./BuddyListGroup.vue?vue&type=script&lang=ts&setup=true"

import "./BuddyListGroup.vue?vue&type=style&index=0&id=b6dd27ce&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b6dd27ce"]])

export default __exports__